import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

interface Props {
  handleClose: () => void;
  isOpen: boolean;
  title: string;
  children: React.ReactNode;
}

const ViewDialog: React.FC<Props> = ({
  handleClose,
  isOpen,
  title,
  children,
}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isFullScreen = useMediaQuery(theme.breakpoints.down("sm")); // Matches small screens

  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      maxWidth="md"
      fullWidth
      fullScreen={isFullScreen}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      PaperProps={{
        sx: {
          height: "90vh",
        },
      }}
    >
      <DialogTitle
        id="alert-dialog-title"
        sx={{
          display: "flex",
          fontWeight: "bold",
          bgcolor: "primary.main",
          color: "white",
          padding: 2,
        }}
      >
        {title}
      </DialogTitle>
      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 4,
          marginTop: 2,
        }}
      >
        {children}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>{t("general.close")}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ViewDialog;
